import React, {useContext, useEffect, useState} from "react";
import $ from "jquery";
import Menu from "./menu/Menu";
import Header from "./header/Header";
import Events from "../tools/event/Events";
import Content from "./contents/Content";
import MyCalendar from "../tools/MyCalendar/MyCalendar";
import CloseIcon from "../icons/CloseIcon";
import Popup from "../overbox/popup/Popup";
import SessionContext from "../../context/SessionContext";
import AppContext from "../../context/AppContext";
import FilterContext from "../../context/FilterContext";
import "../../css/page/Site.css";

const Site = props => {
    const { page } = props;
	const { handleCheckDefinePwd } = useContext(SessionContext);
    const [ event, setEvent ] = useState(null);
    const [ bubbleText, setBubbleText ] = useState(null);
    const [ objectPopup, setObjectPopup ] = useState(null);
    const [ getDatasPopup, setGetDatasPopup ] = useState(null);
    const [ statePopup, setStatePopup ] = useState(null);
    const [ subStatePopup, setSubStatePopup ] = useState(null);
    const [ popupLoadingIcon, setPopupLoadingIcon ] = useState(null);
    const [ popupLoadingText, setPopupLoadingText ] = useState(null);
    const [ nbPage, setNbPage ] = useState(1);
    const [ filters, setFilters ] = useState([]);
    const [ showCalendarTool, setShowCalendarTool ] = useState(false);

    const handleShowCalendarTool = () => {
        setShowCalendarTool(!showCalendarTool);
    }
    const bubbleHunter = () => {
        if (bubbleText === null) {
            window.removeEventListener('mousemove', moveBubble, false)
        }
        else {
            window.addEventListener('mousemove', moveBubble, false)
        }
    }
    const moveBubble = event => {
        let idBubbleItem = "#bubble"
        if ($(idBubbleItem).length === 0) return

        let posX = event.pageX
        let posY = event.pageY

        if ((posX + 10 + $(idBubbleItem).width()) >= ($(document).width() - 60)) {
            posX -= (60 + $(idBubbleItem).width());
        }

        $(idBubbleItem).css({
            left: (posX + 10),
            top: (posY - 35),
        });
    }

	useEffect(() => {
		handleCheckDefinePwd();
	}, []);
    useEffect(() => {
        bubbleHunter();
    }, [bubbleText]);

    const appContextValues = {
        setEvent,
        setBubbleText,
        objectPopup,
        setObjectPopup,
        getDatasPopup,
        setGetDatasPopup,
        statePopup,
        setStatePopup,
        subStatePopup,
        setSubStatePopup,
        popupLoadingIcon,
        setPopupLoadingIcon,
        popupLoadingText,
        setPopupLoadingText
    };
    const sessionContextValues = {
        nbPage,
        setNbPage,
        filters,
        setFilters
    };

    return (
        <AppContext.Provider value={appContextValues}>
            <FilterContext.Provider value={sessionContextValues}>
                <div className="site">
                    <div id={"bubble"} className={"bubbleHover" + (bubbleText !== null ? " visible" : "")}><p>{ bubbleText }</p></div>
                    <Header page={ page } handleShowCalendarTool={ handleShowCalendarTool } />
                    <Menu page={ page } />
                    <div className="page">
                        <Content page={ page } />
                    </div>
                    <Popup />
                    <Events event={ event } />
                    <div className={ "calendarTool" + (showCalendarTool ? " visible" : "") }>
                        <CloseIcon classname="close" handleClick={ handleShowCalendarTool } />
                        <MyCalendar />
                    </div>
                </div>
            </FilterContext.Provider>
        </AppContext.Provider>
    )
}

export default Site;
